import { COLORS } from '@/styles/colors';
import { bodySmall2, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

type StepState = 'done' | 'current' | 'todo';

const STEP_COLORS: Record<StepState, { background: string; color: string }> = {
  done: { background: COLORS.green[200], color: COLORS.green[600] },
  current: { background: COLORS.blue[200], color: COLORS.blue[700] },
  todo: { background: COLORS.grey[200], color: COLORS.grey[600] },
};

export const StepRail = styled.ol`
  display: flex;
  align-items: center;
  gap: 22px;
  margin: 0 0 20px;
  padding: 0;
  list-style: none;
`;

export const StepPill = styled.li<{
  $state: StepState;
  $last: boolean;
}>`
  ${bodySmall2};
  ${poppinsMediumFont};
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  background: ${({ $state }) => STEP_COLORS[$state].background};
  color: ${({ $state }) => STEP_COLORS[$state].color};
  font-weight: 500;

  &::before {
    content: ${({ $last }) => ($last ? 'none' : '""')};
    position: absolute;
    top: 50%;
    left: calc(100% + 4px);
    width: 14px;
    height: 0;
    transform: translateY(-50%);
    border-top: 1px solid ${({ $state }) => STEP_COLORS[$state].color};
  }
`;
